<template>
	<div class="mapWrap">
		<div ref="map" class="map"></div>
	</div>
</template>

<script>
const isequal = require('lodash.isequal');

export default {
	name: "MapWrap",
	props: {
		items: Object,
	},
	computed: {
		isDarkTheme() {
			return !!this.$vuetify.theme.dark;
		}
	},

	watch: {
		isDarkTheme() {
			this.updateThemeLayer();
		},
		items(val, oldVal) {
			if (!isequal(val, oldVal)) {
				this.clearRouteOnly(); // 👈 краще не вбивати всю карту
				this.$nextTick(() => this.drawRoute());
			}
		}

	},
	data() {
		return {
			map: null,
			directions: null,
			ro: null,
			tileLayer: null,
		};
	},

	methods: {
		// initMap() {
		// 	console.log('%c [  initMap  ] ', 'color:#bada55', );
		// 	/* eslint-disable */
		// 	L.mapquest.key = 'hoYouFauJ5H7sCljO6AqA7mJFkDPysoF';
		//
		// 	const map = L.mapquest.map(this.$refs.map, {   // ✅ ось тут
		// 		center: [40.7128, -74.0059],
		// 		layers: L.mapquest.tileLayer('dark'),
		// 		zoom: 13
		// 	});
		//
		// 	const directions = L.mapquest.directions();
		// 	const options = {
		// 		startMarker: {
		// 			draggable: false,
		// 			icon: 'circle',
		// 			iconOptions: {
		// 				size: 'sm',
		// 				primaryColor: '#1fc715',
		// 				secondaryColor: '#1fc715',
		// 				symbol: 'A'
		// 			}
		// 		},
		// 		endMarker: {
		// 			draggable: false,
		// 			icon: 'circle',
		// 			iconOptions: {
		// 				size: 'sm',
		// 				primaryColor: '#e9304f',
		// 				secondaryColor: '#e9304f',
		// 				symbol: 'B'
		// 			}
		// 		},
		// 		waypointMarker: {
		// 			draggable: false,
		// 		},
		// 		routeRibbon: {
		// 			draggable: false,
		// 			opacity: 0.8,
		// 			showTraffic: false
		// 		}
		// 	};
		//
		// 	directions.setLayerOptions(options);
		//
		// 	this.$data.map = map;
		// 	this.$data.directions = directions;
		//
		//
		// 	// ⬇️ ключове: після відкриття/transition розмір стає правильним
		// 	this.forceInvalidateSize();
		//
		// 	// і тільки потім маршрут
		// 	directions.route(this.items);
		//
		// 	// ⬇️ якщо контейнер змінює розмір (діалог, ресайз, колонка) — підліковуємо
		// 	this.connectResizeObserver();
		// },
		forceInvalidateSize() {
			// 2 тики + маленький таймаут — найнадійніше для v-dialog transition
			this.$nextTick(() => {
				this.$nextTick(() => {
					setTimeout(() => {
						if (this.map) this.map.invalidateSize(true);
					}, 50);
				});
			});
		},

		connectResizeObserver() {
			this.disconnectResizeObserver();
			if (!window.ResizeObserver || !this.$refs.map) return;

			this.ro = new ResizeObserver(() => {
				if (this.map) this.map.invalidateSize(false);
			});
			this.ro.observe(this.$refs.map);
		},

		disconnectResizeObserver() {
			if (this.ro) {
				this.ro.disconnect();
				this.ro = null;
			}
		},

		clearMap() {
			if (this.map) {
				this.map.remove();
				this.map = null;
			}
			this.directions = null;
			this.tileLayer = null;
		},

		initMap() {
			if (!this.$refs.map) return;

			/* eslint-disable */
			L.mapquest.key = 'hoYouFauJ5H7sCljO6AqA7mJFkDPysoF';

			// ⚠️ важливо: створюємо карту БЕЗ layers
			this.map = L.mapquest.map(this.$refs.map, {
				center: [40.7128, -74.0059],
				zoom: 13
			});

			this.directions = L.mapquest.directions();
			this.directions.setLayerOptions({
				startMarker: {
					draggable: false,
					icon: 'circle',
					iconOptions: { size: 'sm', primaryColor: '#1fc715', secondaryColor: '#1fc715', symbol: 'A' }
				},
				endMarker: {
					draggable: false,
					icon: 'circle',
					iconOptions: { size: 'sm', primaryColor: '#e9304f', secondaryColor: '#e9304f', symbol: 'B' }
				},
				waypointMarker: { draggable: false },
				routeRibbon: { draggable: false, opacity: 0.8, showTraffic: false }
			});

			// ✅ ставимо правильний шар під тему
			this.updateThemeLayer();

			// ✅ малюємо маршрут
			this.drawRoute();

			this.forceInvalidateSize();
			this.connectResizeObserver();
		},

		updateThemeLayer() {
			if (!this.map) return;

			// прибираємо попередній layer
			if (this.tileLayer) {
				this.map.removeLayer(this.tileLayer);
				this.tileLayer = null;
			}

			// MapQuest: 'dark' або 'light'
			const layerName = this.isDarkTheme ? 'dark' : 'light';
			this.tileLayer = L.mapquest.tileLayer(layerName);
			this.tileLayer.addTo(this.map);

			// після зміни шару корисно “пінати” розмір
			this.forceInvalidateSize();
		},

		drawRoute() {
			if (!this.directions || !this.items) return;
			this.directions.route(this.items);
		},

		// якщо хочеш перерисовувати тільки маршрут (без remove map)
		clearRouteOnly() {
			// у MapQuest directions є layer, який можна прибрати
			// найпростіше: пересоздати directions, але залишити map
			if (!this.map) return;

			if (this.directions) {
				try { this.directions.layer && this.map.removeLayer(this.directions.layer); } catch (e) {}
			}

			this.directions = L.mapquest.directions();
			this.directions.setLayerOptions(/* ті самі options */);
		},

	},
	// beforeDestroy() {
	// 	this.disconnectResizeObserver();
	// 	this.clearMap();
	// },
	// mounted() {
	// 	// важливо: ініт після першого тіку, коли контейнер точно в DOM
	// 	this.$nextTick(() => {
	// 		this.initMap();
	// 	});
	// },
	mounted() {
		this.$nextTick(() => this.initMap());
	},
	beforeDestroy() {
		this.disconnectResizeObserver();
		this.clearMap();
	},
};
</script>
<style scoped lang="scss">
.mapWrap {
	margin-top: 24px;
	.map {
		width: 100%;
		height: 530px;
	}
}
</style>

